import addressee from '../../defaultFieldDefinitions/Addressee';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import formatTrimToUpper from '../../formatTrimToUpper';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';
import {fourDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';

const FieldDefinitionAU = [
  addressee,
  companyName,
  {
    name: 'streetName',
    label: 'checkout.address.field.label.address.text',
    required: true,
    maxLength: 35,
    validate: [required.basic, max.lengthAddress(35)],
  },
  {
    name: 'addressLine2',
    label: 'checkout.address.field.label.AUaddress2.text',
    maxLength: 35,
    validate: max.lengthAddress(35),
  },
  {
    name: 'townCity',
    label: 'checkout.address.field.label.suburb.text',
    required: true,
    maxLength: 35,
    validate: [required.townCity, max.lengthAddress(35)],
  },
  {
    name: 'county',
    label: 'checkout.delivery.address.field.label.stateOrProvince.text',
    element: 'select',
    required: true,
    maxLength: 35,
    validate: [required.county, max.lengthAddress(35)],
    options: [
      {
        value: 'ACT',
        content: 'Australian Capital Territory',
      },
      {
        value: 'NSW',
        content: 'New South Wales',
      },
      {
        value: 'QLD',
        content: 'Queensland',
      },
      {
        value: 'SA',
        content: 'South Australia',
      },
      {
        value: 'TAS',
        content: 'Tasmania',
      },
      {
        value: 'VIC',
        content: 'Victoria',
      },
      {
        value: 'NT',
        content: 'Northern Territory',
      },
      {
        value: 'WA',
        content: 'Western Australia',
      },
    ],
  },
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.AUpostal.code.text',
    required: true,
    transform: formatTrimToUpper,
    validate: [required.postCode, fourDigitsPostcodeValidator],
  },
];

export default FieldDefinitionAU;
